import { createSelector } from 'reselect'
import { getActiveServerId } from '../activeServer/selectors'

export const getProfiles = state => state.backendReducer.serverProfiles || {}
export const getServerProfiles = (state, serverId) => {
    const profiles = getProfiles(state)
    return profiles[serverId] || ['Default']
}
export const getActiveServerProfiles = createSelector(
    [getActiveServerId, getProfiles],
    (active, profiles) => profiles[active] || ['Default'],
)



// WEBPACK FOOTER //
// ./src/features/Backend/data/serverProfiles/selectors.js